import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';


const bannerRoutes: Routes = [
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(bannerRoutes)
  ],
  exports: [RouterModule]
})
export class BannerRoutingModule { }
